export const SMARTCONSENT_CLIENT_ID = '6ruYbugxOXldrNnj4chIcA2uzfkryVLA';
export const SMARTCONSENT_DOMAIN = 'smartconsent.us.auth0.com';
export const SMARTCONSENT_AUDIENCE = 'https://smartconsent.us.auth0.com/userinfo';
export const SMARTCONSENT_AUTH_SCOPE = 'openid profile email';
export const SMARTCONSENT_AUTH_CONNECTION_TYPE = 'google-oauth2';
export const IMAGE_URL = 'https://d51h18g2kuzad.cloudfront.net';
export const ENVIRONMENT = 'prod';
export const FLINKS_DEMO = false;
export const S3_BUCKET = 'ts-application-services-static-websites';
export const MEASUREMENT_ID = 'G-LKGDVYQYTC';
export const SCORING_API_BASE_URL = 'https://appservices.trustscience.com/scoring/v2';
export const LOGROCKET_APPID = '1uegt8/truststartprod';
export const LOGROCKET_CHILD_DOMAINS = ['https://inverite.com'];
export const USE_CHATBOT_LOCAL_FETCH_STRATEGY = false;
